import { DepoCikisIslemiPage } from './../pages/depo-cikis-islemi/depo-cikis-islemi';
import { GunlukGelenUrunlerPage } from './../pages/gunluk-gelen-urunler/gunluk-gelen-urunler';
import { RaporanasayfaPage } from './../pages/raporanasayfa/raporanasayfa';
import { ProgramAyarlariPage } from './../pages/program-ayarlari/program-ayarlari';
import { CariStokSecimPage } from './../pages/cari-stok-secim/cari-stok-secim';
import { StokHareketDetayPage } from './../pages/StokIslemleri/stok-hareket-detay/stok-hareket-detay';
import { DepoKayitlariPage } from './../pages/UreticiIslemleri/depo-kayitlari/depo-kayitlari';
import { FileOpener } from '@ionic-native/file-opener';
import { File } from '@ionic-native/file';
import { PdftestPage } from './../pages/pdftest/pdftest';
import { UreticiBilgisiPage } from './../pages/UreticiIslemleri/uretici-bilgisi/uretici-bilgisi';
import { StokhareketleriPage } from './../pages/StokIslemleri/stokhareketleri/stokhareketleri';
import { UrunAktarModalPage } from './../pages/MalKayit/urun-aktar-modal/urun-aktar-modal';
import { CarisecmodalPage } from './../pages/CariIslemleri/carisecmodal/carisecmodal';
import { MalgiriseklePage } from './../pages/MalKayit/malgirisekle/malgirisekle';
import { MalkayitListePage } from './../pages/MalKayit/malkayit-liste/malkayit-liste';
import { KasiyerBazliRaporPage } from './../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { CarismsgonderPage } from './../pages/CariIslemleri/carismsgonder/carismsgonder';
import { PersonelEkleGuncellePage } from './../pages/CariIslemleri/personel-ekle-guncelle/personel-ekle-guncelle';
import { PersonelListesiPage } from './../pages/CariIslemleri/personel-listesi/personel-listesi';
import { SMS } from '@ionic-native/sms';
import { CallNumber } from '@ionic-native/call-number';
import { Camera } from '@ionic-native/camera';
import { GelirgidereklePage } from './../pages/Yonetim/gelirgider/gelirgiderekle/gelirgiderekle';
import { HareketdetayPage } from './../pages/CariIslemleri/hareketdetay/hareketdetay';
import { CariHareketleriPage } from './../pages/CariIslemleri/cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from './../pages/CariIslemleri/carialacakdekont/carialacakdekont';
import { KullaniciListePage } from './../pages/Yonetim/kullanici-liste/kullanici-liste';
import { KullanicieklePage } from './../pages/Yonetim/kullaniciekle/kullaniciekle';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { EtiketlistesiPage } from './../pages/StokIslemleri/etiketlistesi/etiketlistesi';
import { EtiketbasPage } from './../pages/StokIslemleri/etiketbas/etiketbas';
import { ReportsPage } from './../pages/Raporlars/reports/reports';
import { SatispagePage } from './../pages/Muhasebe/Satis/satispage/satispage';
import { DalProvider } from './../providers/dal/dal';
import { BarcodeScannerProvider } from './../providers/barcode-scanner-provider';
import { CarisecPage } from './../pages/faturaislemleri/carisec/carisec';
import { CariIslemPage } from './../pages/CariIslemleri/cari-islem/cari-islem';
import { GirisPage } from './../pages/giris/giris';
import { SayimGirisiPage } from './../pages/StokIslemleri/sayim-girisi/sayim-girisi';
import { CariOdemePage } from './../pages/cari-odeme/cari-odeme';
import { StokeklePage } from './../pages/StokIslemleri/stokekle/stokekle';
import { HttpModule } from '@angular/http';
import { Ortak } from './../providers/ortak';
import { Servis } from './../providers/servis';
import { BllOrtak } from './../providers/bll/bll-ortak';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { CarieklePage } from './../pages/CariIslemleri/cariekle/cariekle';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { CariTahsilatPage } from '../pages/CariIslemleri/cari-tahsilat/cari-tahsilat';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { CalendarModule } from "ion2-calendar";
import { Flashlight } from '@ionic-native/flashlight';
import { PersonelPage } from '../pages/Yonetim/personel/personel';
import { CariborcdekontPage } from '../pages/CariIslemleri/cariborcdekont/cariborcdekont';
import { GelirgiderPage } from '../pages/Yonetim/gelirgider/gelirgider';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    SatispagePage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    PersonelPage,
    KullanicieklePage,
    KullaniciListePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    PersonelListesiPage,
    PersonelEkleGuncellePage,
    CarismsgonderPage,
    KasiyerBazliRaporPage,
    MalkayitListePage,
    MalgiriseklePage,
    CarisecPage,
    CarisecmodalPage,
    UrunAktarModalPage,
    StokhareketleriPage,
    UreticiBilgisiPage,
    PdftestPage,
    DepoKayitlariPage,
    StokHareketDetayPage,
    CariStokSecimPage,
    ProgramAyarlariPage,
    RaporanasayfaPage,
    GunlukGelenUrunlerPage,
    DepoCikisIslemiPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    CalendarModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    SatispagePage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    PersonelPage,
    KullanicieklePage,
    KullaniciListePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    PersonelListesiPage,
    PersonelEkleGuncellePage,
    CarismsgonderPage,
    KasiyerBazliRaporPage,
    MalkayitListePage,
    MalgiriseklePage,
    CarisecPage,
    CarisecmodalPage,
    UrunAktarModalPage,
    StokhareketleriPage,
    UreticiBilgisiPage,
    PdftestPage,
    DepoKayitlariPage,
    StokHareketDetayPage,
    CariStokSecimPage,
ProgramAyarlariPage,
RaporanasayfaPage,
GunlukGelenUrunlerPage,
DepoCikisIslemiPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    BllOrtak,
    Servis,
    Ortak,
    CallNumber,
    SMS,
    File,
    FileOpener,
    Flashlight,
    { provide: ErrorHandler, useClass: IonicErrorHandler }, Ortak, Servis, AndroidFullScreen, BllOrtak, Camera, BarcodeScannerProvider, DalProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts